// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"308":"8d8ca092","453":"782490f2","517":"6948afde","678":"1f43f618","693":"d7825e90"}[chunkId] + ".chunk.js";
};